import { useJointBillServicePeriodListQuery } from "@services/jointBillServices/queries";
import { type IOverviewJointBillService } from "@services/overview/types";

export const useValidJointBillServicesForPeriod = (
  periodId: number,
): IOverviewJointBillService["jointBillServiceId"][] => {
  const { data: jbsPeriods } = useJointBillServicePeriodListQuery();
  return (
    jbsPeriods
      ?.filter((jbsPeriod) =>
        jbsPeriod.periods.some((p) => p.periodId === periodId),
      )
      .map((jbs) => jbs.jointBillServiceId) ?? []
  );
};
